export default class BookingRoomModal {
    static init(): void {
        const modals = document.querySelectorAll('.room-modal');

        modals.forEach((modal) => {
            const menuToggle = modal.querySelector('.room-modal__item-menu-toggle');
            const menu = modal.querySelector('.room-modal__item-menu');

            if (!menuToggle || !menu) return;
            menuToggle.addEventListener('click', () => {
                menu.classList.toggle('room-modal__item-menu--active');
                menuToggle.classList.toggle('room-modal__item-menu-toggle--active');
            });

            document.addEventListener('click', (e) => {
                if (!menuToggle.contains(e.target as Node) && !menu.contains(e.target as Node)) {
                    menu.classList.remove('room-modal__item-menu--active');
                    menuToggle.classList.remove('room-modal__item-menu-toggle--active');
                }
            });

            const menuButtons = menu.querySelectorAll('.room-modal__item-submit');
            menuButtons.forEach((menuButton) => {
                menuButton.addEventListener('click', () => {

                });
            });

        });

    }
}
